import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
          <div className="mb-8 lg:mb-0">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-vip-crown-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">Casino-Rus.Online</span>
            </div>
          </div>
          <p className="text-gray-400 max-w-md">
            Независимый рейтинг онлайн казино для игроков из России
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="text-lg font-semibold mb-4">Казино</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/rating" className="hover:text-white transition-colors cursor-pointer">Рейтинг казино</Link></li>
              <li><Link to="/bonuses" className="hover:text-white transition-colors cursor-pointer">Бонусы</Link></li>
              <li><Link to="/providers" className="hover:text-white transition-colors cursor-pointer">Провайдеры</Link></li>
              <li><a href="#mobile" className="hover:text-white transition-colors cursor-pointer">Мобильные казино</a></li>
              <li><a href="#live" className="hover:text-white transition-colors cursor-pointer">Live казино</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Информация</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#about" className="hover:text-white transition-colors cursor-pointer">О нас</a></li>
              <li><a href="#reviews" className="hover:text-white transition-colors cursor-pointer">Отзывы</a></li>
              <li><a href="#news" className="hover:text-white transition-colors cursor-pointer">Новости</a></li>
              <li><a href="#blog" className="hover:text-white transition-colors cursor-pointer">Блог</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Помощь</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="#faq" className="hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#support" className="hover:text-white transition-colors cursor-pointer">Поддержка</a></li>
              <li><a href="#terms" className="hover:text-white transition-colors cursor-pointer">Условия</a></li>
              <li><a href="#privacy" className="hover:text-white transition-colors cursor-pointer">Конфиденциальность</a></li>
            </ul>
          </div>

          <div className="text-right">
            <p className="font-serif text-lg mb-2">© Casino-Rus.Online 2026</p>
            <p className="text-gray-400 text-sm mb-4">Все права защищены</p>
            <div className="flex justify-end gap-3">
              <a href="https://t.me" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-telegram-fill text-lg"></i>
              </a>
              <a href="https://vk.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-vk-fill text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 pt-8 border-t border-gray-800">
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/729ba9e38474b8d14479a4389506bdf8.jpg"
              alt="Ответственная игра"
              className="w-full h-48 object-cover"
            />
          </div>

          <div className="flex items-center justify-center">
            <p className="font-serif text-lg text-center leading-relaxed">
              Играйте ответственно.<br />
              Азартные игры могут вызывать зависимость.<br />
              18+
            </p>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-gray-400 text-sm mb-4">
              Подпишитесь на обновления рейтинга и эксклюзивные бонусы
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Ваш email"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-full text-sm focus:outline-none focus:border-blue-600 transition-colors"
              />
              <button className="px-6 py-3 bg-blue-600 rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            © 2026 Casino-Rus.Online. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};